'use client';

import SectionHeader from './SectionHeader';
import SectionHowTo from './SectionHowTo';
import SectionShare from './SectionShare';
import SectionShop from './SectionShop';
import SectionStatistics from './SectionStatistics';
import useFindLoyaltyUserByIdQuery from './query/useFindLoyaltyUserByIdQuery';
import useGetReferralConfig from './query/useGetReferralConfig';

export default function Loyalty() {
  const { data } = useFindLoyaltyUserByIdQuery();
  const { data: config } = useGetReferralConfig();

  return (
    <div className="tw-bg-white sm:tw-bg-greyscale-background tw-pb-16">
      <SectionHeader data={data?.data} />
      <SectionHowTo />
      <SectionShop />
      <SectionStatistics loyalty={data?.data} />
      {config && (
        <div id="referral" className="tw-bg-yellow reeeef">
          <SectionShare
            referralConfig={config.data}
            referralCode={data?.data.referral?.referralCode}
          />
        </div>
      )}
    </div>
  );
}
